import { Color3, InspectableType, PBRMaterial } from '@babylonjs/core';
import { BabylonjsModule } from '@modules/babylonjs/src/BabylonjsModule';
import { Injectable } from '@modules/core';
import { buildSrcUrl } from '@modules/standard';

import * as Materials from '../../assets/materials';

export enum MaterialType {
  GIS_Map = 'GIS_Map',
  GIS_Building = 'GIS_Building',

  Decal_CarRoad = 'Decal_CarRoad',
  Decal_WalkRoad = 'Decal_WalkRoad',
  Decal_PlayGround = 'Decal_PlayGround',
  Decal_Recycle = 'Decal_Recycle',
  Decal_Grass_Spring = 'Decal_Grass_Spring',
  Decal_Grass_Summer = 'Decal_Grass_Summer',
  Decal_Grass_Fall = 'Decal_Grass_Fall',
  Decal_Grass_Winter = 'Decal_Grass_Winter',
  Decal_Water = 'Decal_Water',
  Decal_Gym_Pattern = 'Decal_Gym_Pattern',
  Decal_Parking_Pattern = 'Decal_Parking_Pattern',
  Dong_Frame_Top = 'Dong_Frame_Top',
  Dong_WindowFrame_L = 'Dong_WindowFrame_L',
  Dong_WindowFrame_M = 'Dong_WindowFrame_M',
  Dong_WindowFrame_S = 'Dong_WindowFrame_S',
  Dong_WindowFrame = 'Dong_WindowFrame',
  Dong_WallFrame_L = 'Dong_WallFrame_L',
  Dong_WallFrame_M = 'Dong_WallFrame_M',
  Dong_WallFrame_S = 'Dong_WallFrame_S',
  Dong_WallFrame = 'Dong_WallFrame',
  Dong_LandFill = 'Dong_LandFill',
  Dong_RoofTop = 'Dong_RoofTop',
  ItemFXMaterial = 'ItemFXMaterial',
  DongFXMaterial = 'DongFXMaterial',

  FacilityBuilding = 'FacilityBuilding',
  ParkingEnterance_Glass = 'ParkingEnterance_Glass',
  ParkingEnterance_Entry = 'ParkingEnterance_Entry',
  ParkingEnterance_Frame = 'ParkingEnterance_Frame',
  ParkingEnterance_Letter = 'ParkingEnterance_Letter',

  Tree_Leave_Flower_SpringA = 'Tree_Leave_Flower_SpringA',
  Tree_Leave_Flower_SpringB = 'Tree_Leave_Flower_SpringB',
  Tree_Leave_Flower_SpringC = 'Tree_Leave_Flower_SpringC',
  Tree_Leave_Flower_SpringD = 'Tree_Leave_Flower_SpringD',
  Tree_Leave_Flower_SummerA = 'Tree_Leave_Flower_SummerA',
  Tree_Leave_Flower_SummerB = 'Tree_Leave_Flower_SummerB',
  Tree_Leave_Flower_FallA = 'Tree_Leave_Flower_FallA',
  Tree_Leave_Flower_FallB = 'Tree_Leave_Flower_FallB',
  Tree_Leave_Flower_WinterA = 'Tree_Leave_Flower_WinterA',
  Tree_Leave_Flower_WinterB = 'Tree_Leave_Flower_WinterB',

  Tree_Leave_Normal_SpringA = 'Tree_Leave_Normal_SpringA',
  Tree_Leave_Normal_SpringB = 'Tree_Leave_Normal_SpringB',
  Tree_Leave_Normal_SpringC = 'Tree_Leave_Normal_SpringC',
  Tree_Leave_Normal_SpringD = 'Tree_Leave_Normal_SpringD',
  Tree_Leave_Normal_Summer = 'Tree_Leave_Normal_Summer',
  Tree_Leave_Normal_Fall = 'Tree_Leave_Normal_Fall',
  Tree_Leave_Normal_Winter = 'Tree_Leave_Normal_Winter',

  Tree_Leave_Bush_Spring = 'Tree_Leave_Bush_Spring',
  Tree_Leave_Bush_Summer = 'Tree_Leave_Bush_Summer',
  Tree_Leave_Bush_Fall = 'Tree_Leave_Bush_Fall',
  Tree_Leave_Bush_Winter = 'Tree_Leave_Bush_Winter',

  UnitPanelFXMaterial = 'UnitPanelFXMaterial',
  FakeWindowView = 'FakeWindowView',

  UnitWallEdge = 'UnitWallEdge',
  UnitWallPaper = 'UnitWallPaper',
  UnitBath = 'UnitBath',
  UnitBedLargeFrame = 'UnitBedLargeFrame',
  UnitBedLargeMattress = 'UnitBedLargeMattress',
  UnitBedSmallFrame = 'UnitBedSmallFrame',
  UnitBedSmallMattress = 'UnitBedSmallMattress',
  UnitChestBody = 'UnitChestBody',
  UnitChestPlate = 'UnitChestPlate',
  UnitSinkbasin = 'UnitSinkbasin',
  UnitChair = 'UnitChair',
  UnitCouch = 'UnitCouch',
  UnitDoor = 'UnitDoor',
  UnitFloorBalcony = 'UnitFloorBalcony',
  UnitFloorBath = 'UnitFloorBath',
  UnitFloorGate = 'UnitFloorGate',
  UnitFloorLivingroom = 'UnitFloorLivingroom',
  UnitFloorRoom = 'UnitFloorRoom',
  UnitTable = 'UnitTable',
  UnitToilet = 'UnitToilet',
  UnitWashbasin = 'UnitWashbasin',
  UnitWatertap = 'UnitWatertap',
  UnitWindowGlass = 'UnitWindowGlass',
  UnitWindowFrame = 'UnitWindowFrame',
  UnitWindowNewFrame = 'UnitWindowNewFrame',
  InteriorTourCompass = 'InteriorTourCompass',
  InteriorTourArrow = 'InteriorTourArrow',
  Dummy = 'Dummy',
}

const materialJsons = {
  [MaterialType.GIS_Map]: Materials.GisMap,
  [MaterialType.GIS_Building]: Materials.GisBuilding,
  [MaterialType.Decal_CarRoad]: Materials.DecalCarRoad,
  [MaterialType.Decal_WalkRoad]: Materials.DecalWalkRoad,
  [MaterialType.Decal_PlayGround]: Materials.DecalPlayGround,
  [MaterialType.Decal_Recycle]: Materials.DecalRecycle,
  [MaterialType.Decal_Grass_Spring]: Materials.DecalGrassSpring,
  [MaterialType.Decal_Grass_Summer]: Materials.DecalGrassSummer,
  [MaterialType.Decal_Grass_Fall]: Materials.DecalGrassFall,
  [MaterialType.Decal_Grass_Winter]: Materials.DecalGrassWinter,
  [MaterialType.Decal_Water]: Materials.DecalWater,
  [MaterialType.Decal_Gym_Pattern]: Materials.DecalGymPattern,
  [MaterialType.Decal_Parking_Pattern]: Materials.DecalParkingPattern,
  [MaterialType.Dong_Frame_Top]: Materials.DongFrameTop,
  [MaterialType.Dong_WindowFrame_L]: Materials.DongWindowFrameL,
  [MaterialType.Dong_WindowFrame_M]: Materials.DongWindowFrameM,
  [MaterialType.Dong_WindowFrame_S]: Materials.DongWindowFrameS,
  [MaterialType.Dong_WindowFrame]: Materials.DongWindowFrame,
  [MaterialType.Dong_WallFrame_L]: Materials.DongWallFrameL,
  [MaterialType.Dong_WallFrame_M]: Materials.DongWallFrameM,
  [MaterialType.Dong_WallFrame_S]: Materials.DongWallFrameS,
  [MaterialType.Dong_WallFrame]: Materials.DongWallFrame,
  [MaterialType.Dong_LandFill]: Materials.DongLandFill,
  [MaterialType.Dong_RoofTop]: Materials.DongRoofTop,
  [MaterialType.ItemFXMaterial]: Materials.ItemFXMaterial,
  [MaterialType.DongFXMaterial]: Materials.DongFXMaterial,
  [MaterialType.FacilityBuilding]: Materials.FacilityBuilding,
  [MaterialType.ParkingEnterance_Glass]: Materials.ParkingEnteranceGlass,
  [MaterialType.ParkingEnterance_Entry]: Materials.ParkingEnteranceEntry,
  [MaterialType.ParkingEnterance_Frame]: Materials.ParkingEnteranceFrame,
  [MaterialType.ParkingEnterance_Letter]: Materials.ParkingEnteranceLetter,
  [MaterialType.Tree_Leave_Flower_SpringA]: Materials.TreeLeaveFlowerSpringA,
  [MaterialType.Tree_Leave_Flower_SpringB]: Materials.TreeLeaveFlowerSpringB,
  [MaterialType.Tree_Leave_Flower_SpringC]: Materials.TreeLeaveFlowerSpringC,
  [MaterialType.Tree_Leave_Flower_SpringD]: Materials.TreeLeaveFlowerSpringD,
  [MaterialType.Tree_Leave_Flower_SummerA]: Materials.TreeLeaveFlowerSummerA,
  [MaterialType.Tree_Leave_Flower_SummerB]: Materials.TreeLeaveFlowerSummerB,
  [MaterialType.Tree_Leave_Flower_FallA]: Materials.TreeLeaveFlowerFallA,
  [MaterialType.Tree_Leave_Flower_FallB]: Materials.TreeLeaveFlowerFallB,
  [MaterialType.Tree_Leave_Flower_WinterA]: Materials.TreeLeaveFlowerWinterA,
  [MaterialType.Tree_Leave_Flower_WinterB]: Materials.TreeLeaveFlowerWinterB,
  [MaterialType.Tree_Leave_Normal_SpringA]: Materials.TreeLeaveNormalSpringA,
  [MaterialType.Tree_Leave_Normal_SpringB]: Materials.TreeLeaveNormalSpringB,
  [MaterialType.Tree_Leave_Normal_SpringC]: Materials.TreeLeaveNormalSpringC,
  [MaterialType.Tree_Leave_Normal_SpringD]: Materials.TreeLeaveNormalSpringD,
  [MaterialType.Tree_Leave_Normal_Summer]: Materials.TreeLeaveNormalSummer,
  [MaterialType.Tree_Leave_Normal_Fall]: Materials.TreeLeaveNormalFall,
  [MaterialType.Tree_Leave_Normal_Winter]: Materials.TreeLeaveNormalWinter,
  [MaterialType.Tree_Leave_Bush_Spring]: Materials.TreeLeaveBushSpring,
  [MaterialType.Tree_Leave_Bush_Summer]: Materials.TreeLeaveBushSummer,
  [MaterialType.Tree_Leave_Bush_Fall]: Materials.TreeLeaveBushFall,
  [MaterialType.Tree_Leave_Bush_Winter]: Materials.TreeLeaveBushWinter,
  [MaterialType.UnitPanelFXMaterial]: Materials.UnitPanelFXMaterial,
  [MaterialType.FakeWindowView]: Materials.FakeWindowView,
  [MaterialType.UnitWallEdge]: Materials.UnitWallEdge,
  [MaterialType.UnitWallPaper]: Materials.UnitWallPaper,
  [MaterialType.UnitBath]: Materials.UnitBath,
  [MaterialType.UnitBedLargeFrame]: Materials.UnitBedLargeFrame,
  [MaterialType.UnitBedLargeMattress]: Materials.UnitBedLargeMattress,
  [MaterialType.UnitBedSmallFrame]: Materials.UnitBedSmallFrame,
  [MaterialType.UnitBedSmallMattress]: Materials.UnitBedSmallMattress,
  [MaterialType.UnitChestBody]: Materials.UnitChestBody,
  [MaterialType.UnitChestPlate]: Materials.UnitChestPlate,
  [MaterialType.UnitSinkbasin]: Materials.UnitSinkbasin,
  [MaterialType.UnitChair]: Materials.UnitChair,
  [MaterialType.UnitCouch]: Materials.UnitCouch,
  [MaterialType.UnitDoor]: Materials.UnitDoor,
  [MaterialType.UnitFloorBalcony]: Materials.UnitFloorBalcony,
  [MaterialType.UnitFloorBath]: Materials.UnitFloorBath,
  [MaterialType.UnitFloorGate]: Materials.UnitFloorGate,
  [MaterialType.UnitFloorLivingroom]: Materials.UnitFloorLivingroom,
  [MaterialType.UnitFloorRoom]: Materials.UnitFloorRoom,
  [MaterialType.UnitTable]: Materials.UnitTable,
  [MaterialType.UnitToilet]: Materials.UnitToilet,
  [MaterialType.UnitWashbasin]: Materials.UnitWashbasin,
  [MaterialType.UnitWatertap]: Materials.UnitWatertap,
  [MaterialType.UnitWindowGlass]: Materials.UnitWindowGlass,
  [MaterialType.UnitWindowFrame]: Materials.UnitWindowFrame,
  [MaterialType.UnitWindowNewFrame]: Materials.UnitWindowNewFrame,
  [MaterialType.InteriorTourCompass]: Materials.InteriorTourCompass,
  [MaterialType.InteriorTourArrow]: Materials.InteriorTourArrow,
  [MaterialType.Dummy]: Materials.Dummy,
};

const albedoColorTable: Partial<Record<MaterialType, string>> = {
  [MaterialType.UnitBath]: '#E6E6E6',
  [MaterialType.UnitToilet]: '#E6E6E6',
  [MaterialType.UnitWashbasin]: '#E6E6E6',
  [MaterialType.UnitWatertap]: '#7D7D7D',
  [MaterialType.UnitWindowNewFrame]: '#E1E1E1',
  [MaterialType.UnitChestBody]: '#C8C8C8',
  [MaterialType.UnitChestPlate]: '#B4B4B4',
  [MaterialType.UnitDoor]: '#F0F0F0',
  [MaterialType.UnitSinkbasin]: '#969696',
};

export class MaterialManager implements Injectable {
  static readonly INJECTABLE_TOKEN = Symbol.for('MaterialManager');

  //------------------------------------------------------------------------------------
  // #### System Base ####
  //------------------------------------------------------------------------------------
  private readonly scene;
  constructor({
    [BabylonjsModule.INJECTABLE_TOKEN]: babylonjs,
  }: {
    [BabylonjsModule.INJECTABLE_TOKEN]: Pick<BabylonjsModule, 'scene'>;
  }) {
    this.scene = babylonjs.scene;
    this.loadMaterialData();
  }

  dispose() {
    this.createdMaterials.forEach((mats) => mats.forEach((mat) => mat.dispose(false, true)));
    this.createdMaterials.clear();
  }

  public disposeMaterials(types: MaterialType[]) {
    const baseNames = types.map((t) => MaterialType[t]);
    baseNames.forEach((baseName) => {
      const mats = this.createdMaterials.get(baseName);
      if (!mats) return;
      mats.forEach((mat) => mat.dispose(false, true));
      this.createdMaterials.delete(baseName);
    });
  }

  private baseMaterialData: Map<string, any> = new Map();
  private createdMaterials: Map<string, PBRMaterial[]> = new Map();

  private loadMaterialData() {
    for (const [type, json] of Object.entries(materialJsons)) {
      this.baseMaterialData.set(type, json);
    }
  }

  getBaseMaterialDataSize(): { totalSize: number; entryCount: number; details: Array<{ type: string; size: number }> } {
    let totalSize = 0;
    const details: Array<{ type: string; size: number }> = [];

    for (const [type, json] of this.baseMaterialData.entries()) {
      const jsonString = JSON.stringify(json);
      const size = new Blob([jsonString]).size;
      totalSize += size;
      details.push({ type, size });
    }

    return {
      totalSize,
      entryCount: this.baseMaterialData.size,
      details: details.sort((a, b) => b.size - a.size)
    };
  }

  getCreatedMaterialsSize(): { totalSize: number; entryCount: number; details: Array<{ type: string; size: number; instanceCount: number; textureInfo: { totalSize: number; textures: Array<{ name: string; size: number }> } }> } {
    let totalSize = 0;
    const details: Array<{ type: string; size: number; instanceCount: number; textureInfo: { totalSize: number; textures: Array<{ name: string; size: number }> } }> = [];

    for (const [type, materials] of this.createdMaterials.entries()) {
      let typeSize = 0;
      const textureInfo = {
        totalSize: 0,
        textures: [] as Array<{ name: string; size: number }>
      };

      for (const material of materials) {
        // Material 기본 정보
        const materialData = {
          name: material.name,
          metadata: material.metadata,
          albedoColor: material.albedoColor,
          metallic: material.metallic,
          roughness: material.roughness,
          alpha: material.alpha,
        };
        const jsonString = JSON.stringify(materialData);
        typeSize += new Blob([jsonString]).size;

        // 텍스쳐 정보 수집
        const textures = [
          { name: 'albedoTexture', texture: material.albedoTexture },
          { name: 'metallicTexture', texture: material.metallicTexture },
          { name: 'emissiveTexture', texture: material.emissiveTexture },
          { name: 'ambientTexture', texture: material.ambientTexture },
          { name: 'opacityTexture', texture: material.opacityTexture },
          { name: 'reflectionTexture', texture: material.reflectionTexture },
          { name: 'reflectivityTexture', texture: material.reflectivityTexture },
          { name: 'bumpTexture', texture: material.bumpTexture },
          { name: 'lightmapTexture', texture: material.lightmapTexture },
          { name: 'refractionTexture', texture: material.refractionTexture },
          { name: 'emissiveColor', texture: material.emissiveColor },
          { name: 'ambientColor', texture: material.ambientColor },
          { name: 'reflectionColor', texture: material.reflectionColor },
          { name: 'reflectionTexture', texture: material.reflectionTexture },
        ];

        for (const { name, texture } of textures) {
          if (texture) {
            let textureSize = 0;
            if ('getSize' in texture) {
              const size = texture.getSize();
              textureSize = size.width * size.height * 4; // RGBA = 4 bytes
            }
            textureInfo.totalSize += textureSize;
            textureInfo.textures.push({ name, size: textureSize });
          }
        }
      }

      totalSize += typeSize + textureInfo.totalSize;
      details.push({ 
        type, 
        size: typeSize + textureInfo.totalSize,
        instanceCount: materials.length,
        textureInfo
      });
    }

    return {
      totalSize,
      entryCount: this.createdMaterials.size,
      details: details.sort((a, b) => b.size - a.size)
    };
  }

  getAllMaterialsSize(): { 
    baseData: { totalSize: number; entryCount: number; details: Array<{ type: string; size: number }> };
    createdMaterials: { totalSize: number; entryCount: number; details: Array<{ type: string; size: number; instanceCount: number; textureInfo: { totalSize: number; textures: Array<{ name: string; size: number }> } }> };
    totalSize: number;
  } {
    const baseData = this.getBaseMaterialDataSize();
    const createdMaterials = this.getCreatedMaterialsSize();
    
    return {
      baseData,
      createdMaterials,
      totalSize: baseData.totalSize + createdMaterials.totalSize
    };
  }

  public createMaterial(type: MaterialType, key?: string): PBRMaterial {
    const baseMaterialName = MaterialType[type];
    const materialName = key ? `${baseMaterialName}@${key}` : baseMaterialName;

    const materials = this.createdMaterials.get(baseMaterialName);
    const material = materials?.find((m) => m.name === materialName);
    if (material) {
      return material;
    } else {
      if (materials && materials.length > 0) {
        const mat = materials[0]!.clone(materialName);
        materials.push(mat);
        return mat;
      } else {
        const data = this.baseMaterialData.get(baseMaterialName);
        if (data) {
          const mat = PBRMaterial.Parse(data, this.scene, '');
          const color = albedoColorTable[type];
          if (color) {
            mat.albedoColor = Color3.FromHexString(color).toLinearSpace();
          }
          mat.metadata = {
            ...mat.metadata,
            ...{
              dataPath: buildSrcUrl(`assets/tourDanji/materials/${type}.json`),
              albedoTexture: '',
              metallicTexture: '',
              bumpTexture: '',
              emissiveTexture: '',
              ambientTexture: '',
              detailTexture: '',
              opacityTexture: '',
              reflectionTexture: '',
              reflectivityTexture: '',
            },
          };
          mat.name = materialName;
          this.createdMaterials.set(baseMaterialName, [mat]);
          mat.inspectableCustomProperties = [
            ...(mat.inspectableCustomProperties ?? []),
            {
              type: InspectableType.Checkbox,
              label: 'useParallax',
              propertyName: 'useParallax',
            },
            {
              type: InspectableType.Checkbox,
              label: 'useParallaxOcclusion',
              propertyName: 'useParallaxOcclusion',
            },
            {
              type: InspectableType.Slider,
              label: 'parallaxScaleBias',
              propertyName: 'parallaxScaleBias',
            },
          ];
          return mat;
        } else {
          const mat = new PBRMaterial(materialName, this.scene);
          this.createdMaterials.set(baseMaterialName, [mat]);
          return mat;
        }
      }
    }
  }

  public changeAlbedoColor(color: Color3, type: MaterialType, key: string) {
    const baseMaterialName = `${MaterialType[type]}`;
    const materialName = `${MaterialType[type]}@${key}`;

    const material = this.createdMaterials.get(baseMaterialName)?.find((m) => m.name === materialName);
    if (material) material.albedoColor = color;
  }
}
